import { render, staticRenderFns } from "./ActBanner.vue?vue&type=template&id=726f13bd"
import script from "./ActBanner.vue?vue&type=script&lang=js"
export * from "./ActBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports